import React from 'react';

import { FlexDiv, GenericDiv, GenericP, Headings } from 'commonStyles';

const SectionHeader = ({ heading = {}, logo, description, styles, id })=>{
	const { text, styles: headingStyles = {} } = heading;
	const { headingType = 'h1', fontSize } = headingStyles;
	const { lineHeight } = styles;
	return (
		<FlexDiv left_P='16' id={id} top_P='22'>
			<GenericDiv $width='96px' src={logo} as='img' />
			<GenericDiv left_M='15'>
				<Headings color='700' font_size={fontSize} as={headingType} dangerouslySetInnerHTML={{ __html: text }} />
				<GenericP line_height={lineHeight} top_M='5' dangerouslySetInnerHTML={{ __html: description }} />
			</GenericDiv>
		</FlexDiv>
	);
};

export default SectionHeader;
